import { combineReducers } from "redux";
import booksReducer from "./addBooks/booksReducer";
import filterReducer from "./filterBooks/filterReducer";

const rootReducer = combineReducers({
  books: booksReducer,
  filter: filterReducer,
});
export default rootReducer;
